// Kontaktwege der Praxis an einer Stelle.
//
// Angelegt für die Urlaubs-/Betriebsferien-Hinweise: die verweisen an mehreren
// Stellen auf Telefon und WhatsApp, und drei Kopien derselben Nummer wären
// drei Gelegenheiten, sie auseinanderlaufen zu lassen.
export const PHONE_DISPLAY = '603 31 96 48';
export const PHONE_HREF = 'tel:+34603319648';
export const WHATSAPP_HREF = 'https://wa.me/34603319648';
